import headerTop from "@/components/HeaderTop";
import {
  deepCopy
} from "@/utils/deepCopy.js";
import {
  validatePhone,
  validateEmail,
  validateIdentityCard
} from "@/utils/validate";
import {
  getEnumMetaData
} from "@/utils/getEnumMeta";
import {
  addCompanie
} from "@/http/api/company";
import {
  getCompanySettings
} from "@/http/api/system";
export default {
  components: {
    headerTop,
  },
  data() {
    var validateFormPhone = (rule, value, callback) => {
      if (value === '') {
        callback();
      } else if (!validatePhone(value)) {
        callback(new Error('手机号格式不正确'));
      } else {
        callback();
      }
    };
    var validateFormEmail = (rule, value, callback) => {
      if (value === '') {
        callback();
      } else if (!validateEmail(value)) {
        callback(new Error('邮箱格式不正确'));
      } else {
        callback();
      }
    };
    const validateIdentityCardNumber = (rule, value, callback) => {
      if (!validateIdentityCard(value) && this.company.ownerCardType == "大陆身份证") {
        callback(new Error("身份证号输入不正确"));
      } else {
        callback();
      }
    };
    return {
      headerText: '添加分销商',
      submitLoading: false,
      editPartnersIndex: null,
      //提交参数
      photoUrl: '',
      photoFile: {}, //文件
      company: {
        status: "Waiting", //状态
        partners: [], //股东
        name: '', //名称
        alias: '', //简称
        email: '', //邮箱
        phoneNumber: '', //手机号
        registerAddress: '', //工商注册地址
        currentAddress: '', //实际经营地址
        businessLicense: '', //营业执照号码
        totalMembers: 0, //目标店数
        recruitWay: '', //加盟渠道来源
        nature: '', //公司性质
        hasQualifications: true, //是否有房地产经纪资质
        owner: '', //公司法人
        ownerPhoneNumber: '', //公司法人联系电话
        ownerCardType: '', //公司法人证件类型
        ownerCardNumber: '', //公司法人证件号码
        more: '', //备注
        type: 'Joint_N', //分销商类型
        tags: [], //标签
      },
      companyRules: {
        // totalMembers: [{
        //   required: true,
        //   message: '请输入目标店数',
        //   trigger: 'blur'
        // }],
        // businessLicense: [{
        //   required: true,
        //   message: '请输入营业执照号码',
        //   trigger: 'blur'
        // }],
        name: [{
          required: true,
          message: '请输入分销商名称',
          trigger: 'blur'
        }],
        // owner: [{
        //   required: true,
        //   message: '请输入公司法人',
        //   trigger: 'blur'
        // }],
        // type: [{
        //   required: true,
        //   message: '请选择分销商类型',
        //   trigger: 'change'
        // }],
        // status: [{
        //   required: true,
        //   message: '请选择分销商状态',
        //   trigger: 'change'
        // }],
        // nature: [{
        //   required: true,
        //   message: '请选择公司性质',
        //   trigger: 'change'
        // }],
        // hasQualifications: [{
        //   required: true,
        //   message: '请选择是否有房地产经纪资质',
        //   trigger: 'change'
        // }],
        phoneNumber: [{
          required: false,
          message: '请输入联系电话',
          trigger: 'blur'
        }, {
          validator: validateFormPhone,
          trigger: 'blur'
        }],
        email: [{
          required: false,
          message: '请输入电子邮箱',
          trigger: 'blur'
        }, {
          validator: validateFormEmail,
          trigger: 'blur'
        }],
        // ownerPhoneNumber: [{
        //   required: true,
        //   message: '请输入公司法人联系电话',
        //   trigger: 'blur'
        // }, {
        //   validator: validateFormPhone,
        //   trigger: 'blur'
        // }],
        // ownerCardType: [{
        //   required: true,
        //   message: '请选择公司法人证件类型',
        //   trigger: 'change'
        // }],
        // ownerCardNumber: [{
        //   required: true,
        //   message: '请输入公司法人证件号码',
        //   trigger: 'blur'
        // }, {
        //   validator: validateIdentityCardNumber,
        //   trigger: 'blur'
        // }]
      },
      companyNatureOptions: [], //公司性质
      recruitWayOptions: [], //渠道来源
      companyTypeOptions: [], //分销商类型
      companyStatusOptions: [], //分销商状态
      // 证件类型
      ownerCardTypeOptions: [{
        option: '大陆身份证',
      }, {
        option: '军官证',
      }, {
        option: '港台身份证',
      }, {
        option: '护照',
      }, {
        option: '驾驶证',
      }, {
        option: '其他',
      }],
      isAddPartnersShow: false,
      partnersForm: {
        name: '',
        cardType: '',
        cardNumber: '',
        phoneNumber: '',
        more: ''
      },
      partnersRules: {
        name: [{
          required: true,
          message: '请输入股东姓名',
          trigger: 'blur'
        }],
        cardType: [{
          required: true,
          message: '请选择股东证件类型',
          trigger: 'change'
        }],
        cardNumber: [{
          required: true,
          message: '请输入股东证件号',
          trigger: 'blur'
        }],
        phoneNumber: [{
          required: true,
          message: '请输入股东电话',
          trigger: 'blur'
        }, {
          validator: validateFormPhone,
          trigger: 'blur'
        }]
      }
    }
  },
  mounted() {
    this.getCompanySettings();
    //分销商类型
    this.companyTypeOptions = getEnumMetaData(this.$store.getters.enumMetadata, 'CompanyType');
    //分销商状态
    this.companyStatusOptions = getEnumMetaData(this.$store.getters.enumMetadata, 'CompanyStatus');
  },
  methods: {
    // 获取分销商基础字段
    getCompanySettings() {
      getCompanySettings().then(res => {
        res.result.forEach(item => {
          switch (item.name) {
            case 'Deer.Company.Collection.Nature':
              this.companyNatureOptions = item.value; //分销商公司性质
              break;
            case 'Deer.Company.Collection.RecruitWay':
              this.recruitWayOptions = item.value; //加盟渠道来源
              break;
            case 'Deer.Company.Collection.MaterialType': //资料附件类型
              break;
            case 'Deer.Company.Collection.EventType': //大事记类型
              break;
            case 'Deer.Company.Collection.DropWay': //加盟店退出方式
              break;
            case 'Deer.Company.Collection.MaterialType': //加盟店资料附件类型
              break;
            case 'Deer.Company.Collection.EventType': //加盟店大事记类型
              break;
          }
        });
      });
    },
    //添加分销商
    addCompanie() {
      var formData = new FormData();
      formData.append("Company", JSON.stringify(this.company));
      if (JSON.stringify(this.photoFile) != "{}") {
        formData.append("PhotoFile", this.photoFile);
      }
      addCompanie(formData).then(res => {
        if (res.code == 10200) {
          this.$message({
            showClose: true,
            message: '分销商信息添加成功',
            type: 'success'
          });
          this.$router.go(-1);
        }
        // this.company = this.$options.data().company;
      });
    },
    createCompany(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
        
          this.addCompanie();
        } else {
          return false;
        }
      });
    },
    // 上传头像回调
    uploadChange(file) {
      this.photoUrl = file.url;
    },
    //图片大小
    beforeAvatarUpload(file) {
      const isPIC = file.type.indexOf("image") != -1;
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isPIC) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isPIC && isLt5M;
    },
    //上传图片
    getFile(item) {
      this.photoFile = item.file;
    },
    //添加股东
    addPartners() {
      this.isAddPartnersShow = true;
      this.editPartnersIndex = null;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editPartnersIndex == null) {
            //添加
            this.company.partners.push(deepCopy(this.partnersForm));
          } else {
            //编辑
            this.company.partners.splice(this.editPartnersIndex, 1, deepCopy(this.partnersForm))
          }
          this.$refs[formName].resetFields();
          this.isAddPartnersShow = false;
        } else {
          
          return false;
        }
      });
    },
    handleClose(formName) {
      this.$refs[formName].resetFields();
    },
    // 编辑股东
    editPartners(index, rowData) {
      this.isAddPartnersShow = true;
      this.editPartnersIndex = index;
      this.partnersForm = deepCopy(rowData);
    },
    //删除股东
    deletePartners(index) {
      this.company.partners.splice(index, 1);
    },
  },
};